import "./StickyHeader.scss";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Button from "./Button";

const PACKAGE_ENROLL_PATHS = [
	"/digital-program",
	"/digital-program/constellation",
];

const DEFAULT_LOGO_BEFORE = require("../../assets/bmwLogo_white.webp");
const DEFAULT_LOGO_AFTER = require("../../assets/bmwLogo_grey.png");

function getLogoSrc(logo) {
	return logo?.default ?? logo;
}

function Header({
	logoBeforeScroll = DEFAULT_LOGO_BEFORE,
	logoAfterScroll = DEFAULT_LOGO_AFTER,
	showEnrollButton = true,
}) {
	const [isScrolled, setIsScrolled] = useState(false);
	const { pathname } = useLocation();
	const enrollLink = PACKAGE_ENROLL_PATHS.includes(pathname)
		? "/enroll/package"
		: "/enroll";

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			setIsScrolled(scrollPosition > 100); // Change navigation content after scrolling more than 100px
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<>
			<nav className={`sticky-nav ${isScrolled ? "scrolled" : ""}`}>
				{!isScrolled ? (
					<div className="nav-content-before">
						<div className="logo-text-container">
							<p className="logo-text">BMW Eastern Region</p>
							<p className="logo-text">
								2026 TIER 3 PRODUCTION PROGRAMS
							</p>
						</div>
						<img
							src={getLogoSrc(logoBeforeScroll)}
							alt="BMW Logo"
							className="bmw-logo"
						/>
					</div>
				) : (
					<div className="nav-content-after">
						<div className="logo-container">
							<img
								src={getLogoSrc(logoAfterScroll)}
								alt="BMW Logo"
								className="bmw-logo"
							/>
							<div className="logo-text-container">
								<p className="logo-text">BMW Eastern Region</p>
								<p className="logo-text">
									2026 TIER 3 PRODUCTION PROGRAMS
								</p>
							</div>
						</div>
						{showEnrollButton && (
							<>
								<Button
									link={enrollLink}
									styleName="Blue"
									size="xsmall">
									Enroll Now
								</Button>
							</>
						)}
					</div>
				)}
			</nav>
		</>
	);
}

export default Header;
